module.exports = __webpack_public_path__ + "static/media/orange.2c71a63d.ogg";